import { createContext, useContext } from 'react'

type TaskState = {
  engagementId?: string
  stageId: string
  stepId?: string
  taskId: string
}

const DEFAULT_VALUES = {
  stageId: '',
  taskId: '',
} as TaskState

export const TaskContext = createContext<TaskState>(DEFAULT_VALUES)

export const TaskProvider = ({
  engagementId,
  stageId,
  stepId,
  taskId,
  children,
}: TaskState & { children: React.ReactNode }) => {
  return (
    <TaskContext.Provider value={{ engagementId, stageId, stepId, taskId }}>
      {children}
    </TaskContext.Provider>
  )
}

export const useTaskContext = () => useContext(TaskContext)
